import MinusSVG from "@design-system/ui-icons/vanilla/Minus"
import { createIcon } from "../createIcon"

export const MinusIcon = createIcon(MinusSVG)
